import React from 'react';
import clsx from 'clsx';
import styles from './Panel.module.scss';

interface PanelProps {
    title?: React.ReactNode;
    description?: React.ReactNode;
    actions?: React.ReactNode;
    children?: React.ReactNode;
    className?: string;
    bodyClassName?: string;
}

// Bordered white card (Location details / Dashboard cards pattern).
export const Panel: React.FC<PanelProps> = ({ title, description, actions, children, className, bodyClassName }) => (
    <section className={clsx(styles.root, className)}>
        {(title || actions) && (
            <header className={styles.header}>
                <div className={styles.headings}>
                    {title && <h3 className={styles.title}>{title}</h3>}
                    {description && <p className={styles.description}>{description}</p>}
                </div>
                {actions && <div className={styles.actions}>{actions}</div>}
            </header>
        )}
        {children && <div className={clsx(styles.body, bodyClassName)}>{children}</div>}
    </section>
);

export default Panel;
